/** The green outline of a selected or highlighted item, 1px outside its
 *  border. */
export const HIGHLIGHT_OUTLINE = {
    outline: '2px solid var(--edge-highlight)',
    outlineOffset: 1,
};
/** The width of a line between nodes, and of the short line inside a card
 *  that leads to it. */
export const EDGE_STROKE_WIDTH = 1.5;
// One-shot install of the SVG goo filter + theme CSS vars; DOM-safe to call every mount.
let editorAssetsInstalled = false;
export function installEditorAssets() {
    if (typeof document === 'undefined' || editorAssetsInstalled)
        return;
    if (document.querySelector('[data-super-goo-defs]')) {
        editorAssetsInstalled = true;
        return;
    }
    editorAssetsInstalled = true;
    const host = document.createElement('div');
    host.setAttribute('data-super-goo-defs', '');
    host.innerHTML = `
    <svg aria-hidden style="position:absolute;width:0;height:0;pointer-events:none;overflow:hidden">
      <defs>
        <filter id="super-goo-stem" x="-200%" y="-200%" width="500%" height="500%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="2" />
          <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 22 -10" />
        </filter>
      </defs>
    </svg>
  `;
    document.body.appendChild(host);
    const style = document.createElement('style');
    style.setAttribute('data-super-editor-theme', '');
    style.textContent = `
    :root {
      --edge-highlight: rgb(34, 197, 94);
      --minimap-node: #E4E4E7;
      --minimap-mask: rgba(244, 244, 245, 0.7);
      --minimap-mask-stroke: #D4D4D8;
      --editor-border: #E4E4E7;
    }
    .dark {
      --minimap-node: #3F3F46;
      --minimap-mask: rgba(24, 24, 27, 0.6);
      --minimap-mask-stroke: #52525B;
      --editor-border: #3F3F46;
    }
    /* The graph controls: one rounded panel with flat buttons, like the
       other buttons. No overflow clip, so the Autofit menu can open beside
       it. Autofit sits first. */
    .react-flow__controls.super-controls {
      border: 1px solid var(--editor-border);
      border-radius: 6px;
      background: var(--xy-controls-button-background-color, #fefefe);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    }
    .super-controls .react-flow__controls-button {
      background: transparent;
      border-bottom-color: var(--editor-border);
    }
    .super-controls .react-flow__controls-button:hover {
      background: var(--xy-controls-button-background-color-hover, #f4f4f4);
    }
    .super-controls .super-controls-first {
      order: -1;
    }
    .super-controls .super-controls-first .react-flow__controls-button {
      border-radius: 5px 5px 0 0;
      border-bottom: 1px solid var(--editor-border);
    }
    .super-controls .react-flow__controls-interactive {
      border-radius: 0 0 5px 5px;
      border-bottom: none;
    }
  `;
    document.head.appendChild(style);
}
//# sourceMappingURL=editor-styles.js.map